import { cn } from "#/lib/utils";

/** Small uppercase eyebrow label with a flame tick. */
export function SectionLabel({
  children,
  tone = "dark",
  className,
}: {
  children: React.ReactNode;
  tone?: "dark" | "light";
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em]",
        tone === "dark" ? "text-concrete-dark" : "text-flame-light",
        className,
      )}
    >
      <span className="h-px w-6 bg-flame" />
      {children}
    </span>
  );
}
